import { Product } from '../types/shopify/product';
import { ProductOption } from '../types/shopify/productOption';
import { filterDefaultShopifyOptions } from './shopifyHelpers';

export function getShopifyProductOptionNames(product?: Product) {
  if (!product) {
    return [];
  }
  const options = (filterDefaultShopifyOptions(product.options) || []) as ProductOption[];
  return options.map((option) => option.name.toLowerCase());
}
